<template>
  <b-card>
    <div slot="header">
      <h4 class="mr-5 pull-left">{{$t('COMPETENT_AUTHORITIES')}}</h4>
      <new-button button_type="new" variant="primary" class="pull-right"  @click="addNew">
        {{$t('NEW_COMPETENT_AUTHORITY')}}
      </new-button>
    </div>
    <app-aside  v-model="aside">
      <template slot="header">
        <div v-if="editCompetentAuthority">
          {{$t('EDIT_COMPETENT_AUTHORITY')}}

        </div>
        <div v-else>
          {{$t('NEW_COMPETENT_AUTHORITY')}}
        </div>
      </template>
      <confirmation-dialog :message="$t('DELETE_DEFAULT_MSG')" :show="showDeleteDialog" @confirm="deleteItem" @cancel="showDeleteDialog=false"> </confirmation-dialog>
      <template v-slot:activation v-if="editCompetentAuthority">
        <DeleteButton @click="showDeleteDialog=true"></DeleteButton>
<!--
        <app-button v-if="editCompetentAuthority && editCompetentAuthority.active" variant="danger" :loading="loader_deactivate" @click="deactivate(editCompetentAuthority.header_id)">{{$t('DEACTIVATE')}}</app-button>
        <app-button v-else  :loading="loader_activate" @click="activate(editCompetentAuthority.header_id)">{{$t('ACTIVATE')}}</app-button>
-->

      </template>
      <CompetentAuthorityLanguageWrapper  @success="()=>{actionSetCompetentAuthorities();aside = false;}" :header="editCompetentAuthority"/>

    </app-aside>
    <div class="position-relative">
      <div class="table-container">
        <b-table :tbody-tr-class="rowClass" class="applicant_table animated fadeIn"  responsive hover  :fields="fields" :items="competentAuthorities" primary-key="id">
          <template v-slot:cell(num)="data">
            {{data.index + 1}}
          </template>
          <template v-slot:cell(edit)="data">
            <app-button class="pull-right" @click="edit(data.item)"
                        size="sm"
                        variant="link">
              <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </app-button>
          </template>
        </b-table>
      </div>
    </div>
  </b-card>
</template>

<script>
import AppAside from '@/components/app/form/AppAside'
import NewButton from '@/components/app/AppButton'
import AppButton from "@/components/app/AppButton";
import routeNames from '@/router/routeNames'
import AppSubmit from "@/components/app/AppSubmit";
import {mapActions, mapGetters} from "vuex";
import CompetentAuthorityLanguageWrapper from "@/components/competentAuthority/CompetentAuthorityLanguageWrapper.vue";
import DeleteButton from "@/components/app/AppDelete.vue";
import ConfirmationDialog from "@/components/app/form/AppConfirmationDialog.vue";
import {
  activateCompetentAuthority,
  deactivateCompetentAuthority,
  deleteCompetentAuthority
} from "@/services/competentAuthority";
import {toast} from "@/shared/plugins/toastr";
import {getErrorMessage} from "@/mixins/error/getErrorMessage";
export default {
  name: "index",
  mixins: [getErrorMessage],
  data(){
    return {
      fields: [
        {key: 'num', label: 'Rb'},
        {key: 'name', label: this.$t('NAME')},
        {key: 'city', label: this.$t('CITY')},
        {key: 'email', label: this.$t('EMAIL')},
        {key: 'phone', label: this.$t('PHONE')},
        {key: 'edit', label: ''},
      ],
      routeNames,
      aside: false,
      editCompetentAuthority: null,
      showDeleteDialog: false,
      loader_deactivate: false,
      loader_activate: false,
    }
  },
  components:{
    ConfirmationDialog,
    DeleteButton,
    CompetentAuthorityLanguageWrapper,
    AppSubmit,
    NewButton,
    AppAside,
    AppButton,
  },
  computed: {
    ...mapGetters('competentAuthority', ['competentAuthorities']),
  },
  methods: {
    ...mapActions('competentAuthority', ['actionSetCompetentAuthorities']),
    closePanel() {
      this.aside = false;
      this.editCompetentAuthority = null;
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.translationNotComplete === true) return 'table-lang-not-complete'
    },
    addNew() {
      this.aside = true;
      this.editCompetentAuthority = null;
    },
    edit(competentAuthority) {
      this.aside = true;
      this.editCompetentAuthority = competentAuthority;
    },
    closeAndReload() {
      this.aside = false;
      this.actionSetCompetentAuthorities();
    },
    deactivate(){
      this.loader_deactivate = true;
      deactivateCompetentAuthority(id).then(() => {
        this.closeAndReload();
      }, (error) => {
        toast({
          'title': "Greška",
          'message': this.getMessages(error),
          'type': 'error',
          'timeout': 6000
        })
      }).finally(() => {
        this.loader_deactivate = false;
      })
    },
    activate(id) {
      this.loader_activate = true;
      activateCompetentAuthority(id).then(() => {
        this.closeAndReload();
      }, (error) => {
        toast({
          'title': "Greška",
          'message': this.getMessages(error),
          'type': 'error',
          'timeout': 6000
        })
      }).finally(() => {
        this.loader_activate = false;
      })
    },
    deleteItem(){
      deleteCompetentAuthority(this.editCompetentAuthority.id).then(() => {
        this.showDeleteDialog = false;
        this.aside = false
        this.actionSetCompetentAuthorities();
      })
    }
  },
}
</script>

<style scoped>

</style>
